var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.75C4.66848 5.75 4.35054 5.8817 4.11612 6.11612C3.8817 6.35054 3.75 6.66848 3.75 7V17C3.75 17.3315 3.8817 17.6495 4.11612 17.8839C4.35054 18.1183 4.66848 18.25 5 18.25H19C19.3315 18.25 19.6495 18.1183 19.8839 17.8839C20.1183 17.6495 20.25 17.3315 20.25 17V7C20.25 6.66848 20.1183 6.35054 19.8839 6.11612C19.6495 5.8817 19.3315 5.75 19 5.75H5ZM3.05546 5.05546C3.57118 4.53973 4.27065 4.25 5 4.25H19C19.7293 4.25 20.4288 4.53973 20.9445 5.05546C21.4603 5.57118 21.75 6.27065 21.75 7V17C21.75 17.7293 21.4603 18.4288 20.9445 18.9445C20.4288 19.4603 19.7293 19.75 19 19.75H5C4.27065 19.75 3.57118 19.4603 3.05546 18.9445C2.53973 18.4288 2.25 17.7293 2.25 17V7C2.25 6.27065 2.53973 5.57118 3.05546 5.05546ZM5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H6.01C6.42421 7.25 6.76 7.58579 6.76 8C6.76 8.41421 6.42421 8.75 6.01 8.75H6C5.58579 8.75 5.25 8.41421 5.25 8ZM9 7.25C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75H9.01C9.42421 8.75 9.76 8.41421 9.76 8C9.76 7.58579 9.42421 7.25 9.01 7.25H9Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.f9673c0a802686c942bd8dd27d71457e.svg";
export { ForwardRef as ReactComponent };